// Booststrap - pouze pouzite moduly:
import { Alert, Button, Collapse, Dropdown, Modal, Offcanvas, Popover, Tab } from 'bootstrap';

import { ServerMap } from './components/mod.servermap';
import { processPageContent } from './components/pageContent';
import { initPhotoSwipeGallery, initPhotoSwipeSingleImage } from './components/photoSwipeGallery';
import {
    FADE_IN_ANIMATION_TIME,
    FADE_OUT_ANIMATION_TIME,
    NAVIGATION_ANIMATION_DURATION,
    SCREEN_WIDTH_TABLET,
} from './constants';
import { trackCustomEvent } from './helpers/analytics';
import { createCookie, eraseCookie, getCookie, readCookie } from './helpers/cookies';
import { markInvalidControls } from './helpers/forms';
import {
    addClass,
    delay,
    fadeIn,
    fadeOut,
    fadeToggle,
    getChildren,
    getClosesParent,
    getRandomString,
    getURLParameter,
    getWindowsHeight,
    hasClass,
    removeClass,
    stripHtml,
} from './helpers/generic';
import { modalBackdropResize } from './helpers/modals';
import type { IWebsite } from './typings/website';

const website: IWebsite = window.__WEBSITE__ || {
    App: {},
    AppSettings: {},
    AppStrings: {},
};

website.App = {
    ...website.App,
    Bootstrap: {
        Alert,
        Button,
        //Carousel,
        Collapse,
        Dropdown,
        Modal,
        Offcanvas,
        Popover,
        //ScrollSpy,
        Tab,
        //Toast,
        //Tooltip
    },
    fadeIn,
    fadeOut,
    fadeToggle,
    hasClass,
    addClass,
    removeClass,
    getClosesParent,
    getChildren,
    stripHtml,
    getURLParameter,
    getWindowsHeight,
    trackCustomEvent,
    delay,
    createCookie,
    readCookie,
    getCookie,
    eraseCookie,
    getRandomString,
    modalBackdropResize,
    processPageContent,
    // Forms
    markInvalidControls,
    // PhotoSwipe Lightbox
    initPhotoSwipeSingleImage,
    initPhotoSwipeGallery,
    // Sitemap:
    ServerMap,
};

website.AppSettings = {
    ...website.AppSettings,
    SCREEN_WIDTH_TABLET,
    NAVIGATION_ANIMATION_DURATION,
    FADE_IN_ANIMATION_TIME,
    FADE_OUT_ANIMATION_TIME,
};

window.__WEBSITE__ = website;
